import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import React from 'react';
import { DndGoalListCard } from 'shared/components/ui/goal-list-card';
import { Goal as GoalType } from 'shared/types/goal';

import * as Styled from './task-goal-section-list.style';

export type GoalsListProps = Omit<
  React.ComponentProps<typeof DndGoalListCard>,
  // todo: figure out isDragging and isHovered
  'goal' | 'isDragging' | 'isMoving' | 'isHovered' | 'hideLifeArea'
> & {
  allGoals: GoalType[];
  canCreateTask?: boolean;
  noRightSpacing?: boolean;
  hasDnd?: boolean;
};

export const GoalsList: React.FC<GoalsListProps> = ({
  goals,
  noRightSpacing,
  hasDnd,
  allGoals,

  ...rest
}) => {
  const SortableContainer = hasDnd ? SortableContext : React.Fragment;
  const sortableProps = hasDnd
    ? {
        items: goals.map(({ id }) => id),
        strategy: verticalListSortingStrategy,
      }
    : {};

  return (
    // @ts-ignore
    <SortableContainer {...sortableProps}>
      <Styled.List $noRightSpacing={!!noRightSpacing}>
        {goals.map((goal) => (
          <Styled.ListItem key={goal.id}>
            <Styled.GoalContainer>
              <DndGoalListCard
                goal={goal}
                goals={allGoals}
                {...rest}
                hideLifeArea
              />
            </Styled.GoalContainer>
          </Styled.ListItem>
        ))}
      </Styled.List>
    </SortableContainer>
  );
};
